import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InsuredDTO } from 'app/header-footer-template/model/InsuredDTO';
import { DomainService } from './domain-service';

@Injectable({
    providedIn: 'root'
})
export class InsuredServiceService {

    constructor(
        private http: HttpClient,
        private domainService: DomainService
    ) {}

    getByPolicy(policySequence: number): Promise<any> {
        const url = this.domainService.backendUrlWithContext + '/policies/' + policySequence + '/insureds';
        return this.http.get(url).toPromise();
    }

    /**
     * Recupera todos los asegurados de todas las pólizas DJ29 (Asistencia Jurídica Familiar)
     * del usuario logado. Cada asegurado incluye el POLIZSEC de su póliza (policySequence).
     */
    getAll(): Promise<any> {
        const url = this.domainService.backendUrlWithContext + '/policies/insureds';
        return this.http.get(url).toPromise();
    }

    create(policySequence: number, dto: InsuredDTO): Promise<any> {
        const url = this.domainService.backendUrlWithContext + '/policies/' + policySequence + '/insured';
        return this.http.post(url, dto).toPromise();
    }

    modify(policySequence: number, dto: InsuredDTO): Promise<any> {
        const url = this.domainService.backendUrlWithContext + '/policies/' + policySequence + '/insured';
        return this.http.put(url, dto).toPromise();
    }

    delete(policySequence: number, documentNumber: string): Promise<any> {
        const url = this.domainService.backendUrlWithContext + '/policies/' + policySequence + '/insured/' + documentNumber;
        return this.http.delete(url).toPromise();
    }
}
